import Incentives from "./pages/incentives/store";

export default {
  namespaced: true,
  modules: {
    Incentives,
  },
};
